// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"6bfc4238","968":"04477fea"}[chunkId] + ".chunk.js";
};